import React from 'react';
import {createRoot} from 'react-dom/client';
import * as serviceWorker from './serviceWorker';
import {Provider} from 'react-redux';
import store from './store';
import InitApp from "./InitApp";
import axios from "axios";
import {installUnauthorizedInterceptor} from "helpers/handleUnauthorized";
import {ConfigProvider} from "antd";
import bgBG from "antd/locale/bg_BG";
import dayjs from "dayjs";
import "dayjs/locale/bg";
import moment from "moment";
import "moment/locale/bg";

installUnauthorizedInterceptor(axios);

// The admin is Bulgarian-only: AntD's built-in texts (date pickers, empty
// tables, confirm buttons) and month/day names from dayjs/moment follow suit.
dayjs.locale("bg");
moment.locale("bg");

const app = (

    <Provider store={store}>
        <ConfigProvider locale={bgBG}>
            <InitApp />
        </ConfigProvider>
    </Provider>

);

createRoot(document.getElementById('root')).render(app);
serviceWorker.unregister();
